import { AugmentationToolbarOptionNode } from "@pathwright/ux/src/components/augmentation/AugmentationToolbar"
import {
  AugmentationPanelLegacyForm,
  withAugmentationPanelLegacyForm
} from "@pathwright/ux/src/components/augmentation/AugmentationPanelLegacyForm"
import GroupAccessFormContainer from "./access/GroupAccessFormContainer"
import GroupCommerceFormContainer from "./commerce/GroupCommerceFormContainer"
import { GroupDetailsConnected } from "./details/GroupDetailsCard"

// These forms are also the `/manage/group/…` Cards, so they're dressed for the
// panel here — at the node only the panel reads — rather than in the components.
export const groupManageToolbar: AugmentationToolbarOptionNode = {
  key: "group-manage",
  path: "manage/group/:resourceId/:cohortId",
  label: "Manage",
  // These forms were laid out for a Card, so they ask the panel for Card room.
  panelWidth: "wide",
  middleware: ({ match }) => {
    window.App.getStore("groupAdmin").action.loadGroup(
      match.params.resourceId,
      match.params.cohortId
    )
  },
  AugmentationComponent: () => {
    return (
      <AugmentationPanelLegacyForm>
        <GroupDetailsConnected
          hideFeaturesCardLink
          hideCommunitySettingsCardLink
          // The Offer panel above already links to both of these, so in the
          // panel they're a second door to a room you just came from.
          hideAccessCardLink
          hideCommerceCardLink
          hideArchiveCardLink
        />
      </AugmentationPanelLegacyForm>
    )
  },
  children: [
    {
      key: "access",
      label: "Access",
      AugmentationComponent:
        withAugmentationPanelLegacyForm(GroupAccessFormContainer)
    },
    {
      key: "commerce",
      label: "Commerce",
      AugmentationComponent: withAugmentationPanelLegacyForm(
        GroupCommerceFormContainer
      )
    }
  ]
}
